import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceMenuService {
  public visibleMenu = true;

  constructor() { }
  public showMenu() {
    this.visibleMenu = true;
  }
  public closeMenu() {
    this.visibleMenu = false;
  }
}
